import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Ad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import 'react-calendar/dist/Calendar.css';
import Loader from '../Loader';
import axios from '../Axiosinstance';
import ContractLetter from './ContractLetter';
import OfferLetter from './OfferLetter';
import InvoiceStudent from './InvoiceStudent'; // Import InvoiceStudent component
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import TablePaginationActions from '@mui/material/TablePagination/TablePaginationActions';
import { toast } from 'react-toastify'; // Import toast
import 'react-toastify/dist/ReactToastify.css'; // Import toast css

const Student = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [letterType, setLetterType] = useState(null); // 'offer', 'contract', 'invoice', or 'approve'

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      try {
        const response = await axios.get('api/v1/stripe/list-sessions');
        setRows(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching payment details:', error);
        setIsLoading(false);
      }
    };

    fetchPaymentDetails();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleLetterButtonClick = async (sessionId, status, type) => {
    try {
      const response = await axios.get(`registrationadvances/info/session/${sessionId}`);
      setSelectedRowData({ session: response.data, status: status });
      setLetterType(type);
      setOpenDialog(true);
    } catch (error) {
      console.error('Error fetching session details:', error);
    }
  };

  const handleApproveConfirmation = async () => {
    if (selectedRowData && selectedRowData.session) {
      const studentId = selectedRowData.session.studentId;
      try {
        // Call the first API
        await axios.put(`/home/${studentId}/activate`);

        // Call the second API
        await axios.put(`/student/${studentId}/activate`);

        // Show toast message upon successful approval
        toast.success(`Student ${selectedRowData.session.name} has been approved successfully!`, {
          position: toast.POSITION.TOP_RIGHT
        });
      } catch (error) {
        // Handle errors if any
        console.error('Error approving student:', error);
        toast.error('Failed to approve student. Please try again later.', {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    } else {
      toast.error('No session data available for approval.', {
        position: toast.POSITION.TOP_RIGHT
      });
    }
    handleCloseDialog(); // Close the dialog after handling approval
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setLetterType(null); // Reset the letter type when closing
  };

  return (
    <div className="container-fluid" style={{ maxWidth: '1200px' }}>
      <h2 className="heading" align="center" style={{ color: '#FFFFFF', fontSize: '28px', marginTop: '35px' }}>
        Student Payment
      </h2>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((payment, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{payment.name}</TableCell>
                      <TableCell>${payment.amount / 100}</TableCell>
                      <TableCell>
                        {payment.paid === 'unpaid' ? (
                          <FontAwesomeIcon
                            beat
                            icon={faCircleXmark}
                            size="2x"
                            style={{ marginBottom: '15px', color: '#ff0000' }}
                          />
                        ) : (
                          <FontAwesomeIcon
                            beat
                            icon={faCheck}
                            size="2x"
                            style={{ marginBottom: '15px', color: '#006b4b' }}
                          />
                        )}
                      </TableCell>
                      <TableCell>
                        {payment.paid !== 'unpaid' && (
                          <>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => handleLetterButtonClick(payment.sessionId, payment.paid, 'offer')}
                              style={{ marginRight: '8px', marginBottom: '8px' }}
                            >
                              Offer Letter
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => handleLetterButtonClick(payment.sessionId, payment.paid, 'contract')}
                              style={{ marginRight: '8px', marginBottom: '8px' }}
                            >
                              Contract Letter
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => handleLetterButtonClick(payment.sessionId, payment.paid, 'invoice')}
                              style={{ marginRight: '8px', marginBottom: '8px' }}
                            >
                              Invoice
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleLetterButtonClick(payment.sessionId, payment.paid, 'approve')}
                              style={{ marginBottom: '8px' }}
                            >
                              Approve
                            </Button>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableContainer>
          <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="lg">
            <DialogTitle>
              {letterType === 'offer' ? 'Offer Letter' : letterType === 'contract' ? 'Contract Letter' : letterType === 'invoice' ? 'Invoice' : 'Approve Session'}
            </DialogTitle>
            <DialogContent>
              {letterType ? (
                letterType === 'offer' ? (
                  <OfferLetter sessionId={selectedRowData?.session.id} />
                ) : letterType === 'contract' ? (
                  <ContractLetter sessionId={selectedRowData?.session.id} />
                ) : letterType === 'invoice' ? (
                  <InvoiceStudent sessionId={selectedRowData?.session.id} />
                ) : (
                  <div>
                  Name: {selectedRowData?.session.sureName}<br/>
                  Email: {selectedRowData?.session.email}
                  <p>Are you sure you want to approve this student?</p>
                </div>                )
              ) : (
                <TableContainer component={Paper}>
                  <Table>
                    <TableBody>
                      {selectedRowData && (
                        <>
                          <TableRow>
                            <TableCell>Invoice Number</TableCell>
                            <TableCell>
                              {selectedRowData.status === 'unpaid' ? '-' : `INVJA${selectedRowData.session.id}`}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>{selectedRowData.session.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Status</TableCell>
                            <TableCell>{selectedRowData.status}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Registration Date</TableCell>
                            <TableCell>{selectedRowData.session.date}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Email</TableCell>
                            <TableCell>{selectedRowData.session.email}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Address</TableCell>
                            <TableCell>{selectedRowData.session.addressHome}</TableCell>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </DialogContent>
            <DialogActions>
              {letterType === 'approve' && (
                <Button onClick={handleApproveConfirmation} color="primary">
                  Confirm
                </Button>
              )}
              <Button onClick={handleCloseDialog}>Close</Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default Student;
